module.exports = __webpack_public_path__ + "static/media/valor2.7a167f09.png";